module.exports = __webpack_public_path__ + "static/image 8-5b7c0cd84d659b8673de296c03d262df.png";